import React from "react";
import ErrorPopup, { ErrorPopupProps } from "components/ErrorPopup";
import useTranslate from "hooks/useTranslate";
import { Button, HStack, Icon } from "@chakra-ui/react";
import { FaInfo } from "react-icons/fa";

type UnselectedBearsConfirmPopupProps = Omit<
  ErrorPopupProps,
  "title" | "description"
> & {
  selectedCount?: number;
  onConfirm: () => void;
  onCancel: () => void;
};

const UnselectedBearsConfirmPopup: React.FC<
  UnselectedBearsConfirmPopupProps
> = ({ isOpen, onConfirm, onCancel, selectedCount = 0 }) => {
  const translate = useTranslate();

  return (
    <ErrorPopup
      isOpen={isOpen}
      icon={<Icon as={FaInfo} w="8" h="8" />}
      title={translate("claim:unselectedPopup:title")}
      description={translate("claim:unselectedPopup:description")}
    >
      <HStack spacing={2}>
        <Button onClick={onCancel} w="full" colorScheme="dark">
          {translate("claim:unselectedPopup:cancel")}
        </Button>
        <Button onClick={onConfirm} w="full" colorScheme="secondary">
          {translate("claim:unselectedPopup:confirm", { count: selectedCount })}
        </Button>
      </HStack>
    </ErrorPopup>
  );
};

export default UnselectedBearsConfirmPopup;
